export const PRODUCT_PATH_IMAGE =
  '/static/images/business/pre-subscription/home/product_path.svg';

export const ASSESSMENTS_ICON =
  '/static/images/business/pre-subscription/home/assessments.svg';
export const COUNTRIES_ICON =
  '/static/images/business/pre-subscription/home/countries.svg';
export const COMMUNITY_ICON =
  '/static/images/business/pre-subscription/home/community.svg';

export const ECOSYSTEM_SOURCE_IMAGE =
  '/static/images/business/business-landing-page/Group 21507.png';
export const ECOSYSTEM_SCREEN_IMAGE =
  '/static/images/business/business-landing-page/Group 21512.png';
export const ECOSYSTEM_INNOVATE_IMAGE =
  '/static/images/business/business-landing-page/Group 21510.png';
export const ECOSYSTEM_TRAIN_IMAGE =
  '/static/images/business/business-landing-page/Group 21511.png';

export const ASSESS_PRODUCT_IMAGE =
  '/static/images/business/pre-subscription/home/assess.png';
export const AICHALLENGES_PRODUCT_IMAGE =
  '/static/images/business/pre-subscription/home/ai-challenges.png';

export const AI_CHALLENGES_LANDING_PAGE =
  'https://aiplanet.com/blog/ai-challenges/';
